"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spawnOptionsPlugin = void 0;
const utils_1 = require("../utils");
function spawnOptionsPlugin(spawnOptions) {
    const options = utils_1.pick(spawnOptions, ['uid', 'gid']);
    return {
        type: 'spawn.options',
        action(data) {
            return Object.assign(Object.assign({}, options), data);
        },
    };
}
exports.spawnOptionsPlugin = spawnOptionsPlugin;
//# sourceMappingURL=spawn-options-plugin.js.map